/* global Ad */
import { initComparedForSearchResults } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Compare';
import { initFavoritesForSearchResults } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Favorites';
import { facilityCard } from '@PROJECT_ROOT/assets/desktop/js/search/FacilityCard';

$(() => {
    initializeSearchResults();
});

$(document).on('pjax:success', initializeSearchResults);

function initializeFacilityCards() {
    document.querySelectorAll('#searchResults > li[data-facility-id]').forEach((facility) => {
        facilityCard({ facility })();
    });
}

function initGeolandingZoom() {
    $(document).on('click', '.geoLandContent', function geoLandContentClick() {
        $(this).toggleClass('zoom');
    });
}

function toggleActiveMenuTabs() {
    $('#homepageTab').removeClass('active');
    $('#privatepageTab').addClass('active');
}

function sendGoogleAnalyticsCustomDimensionsEvents() {
    const facilityIds = $('#searchResults').data('facility-ids');
    Ad.GAdimensions.sendHrental(
        facilityIds ? facilityIds.join(',') : '',
        'searchresults',
        '',
        $('#SearchPrivateFilterForm_from').val(),
        $('#SearchPrivateFilterForm_to').val(),
    );
}

function initializeSearchResults() {
    initFavoritesForSearchResults();
    initComparedForSearchResults();
    initializeFacilityCards();

    initGeolandingZoom();
    toggleActiveMenuTabs();
    sendGoogleAnalyticsCustomDimensionsEvents();
}
